import React from 'react'
import { IoIosArrowForward } from "react-icons/io";

const TourHeader = () => {
  return (
    <>
      <section id="hero" className="main-banner">
        <div className="container">
          <div className="breadcrumb-block">
            <h1 className="text-white">Tour</h1>
            <div className="breadcrumb-merge">
              <a href="/" className="breadcrumb">
                Home
              </a>
              <div className="icon"></div>
              <IoIosArrowForward />
              <div className="breadcrumb">Tour</div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default TourHeader
